import {
  EDIT_PROFILE_ERROR,
  EDIT_PROFILE_SUCCESS,
  EDIT_PROFILE,
  RESET_PROFILE_FLAG,
  GET_PROFILE,
  GET_PROFILE_SUCCESS,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  API_ERROR,
  CHANGE_PASSWORD_ERROR,
  UPDATE_PROFILE_AVATAR,
  UPDATE_PROFILE_AVATAR_SUCCESS,
  UPDATE_PROFILE_AVATAR_ERROR,
  GET_PROFILE_ERROR,
} from "./actionTypes";

export const getProfile = () => {
  return {
    type: GET_PROFILE,
  };
};

export const getProfileSuccess = (user) => {
  return {
    type: GET_PROFILE_SUCCESS,
    payload: user,
  };
};

export const getProfileFailure = (error) => {
  return {
    type: GET_PROFILE_ERROR,
    payload: error,
  };
};

export const editProfile = (user) => {
  return {
    type: EDIT_PROFILE,
    payload: { user },
  };
};

export const editProfileSuccess = (user) => {
  return {
    type: EDIT_PROFILE_SUCCESS,
    payload: user,
  };
};

export const editProfileError = (error) => {
  return {
    type: EDIT_PROFILE_ERROR,
    payload: error,
  };
};

export const resetProfileFlag = (error) => {
  return {
    type: RESET_PROFILE_FLAG,
  };
};

export const changePassword = (changes) => {
  return {
    type: CHANGE_PASSWORD,
    payload: { changes },
  };
};

export const changePasswordSuccess = (msg) => {
  return {
    type: CHANGE_PASSWORD_SUCCESS,
    payload: msg,
  };
};

export const changePasswordError = (error) => {
  return {
    type: CHANGE_PASSWORD_ERROR,
    payload: error,
  };
};

export const updateProfileAvatar = (avatar) => {
  return {
    type: UPDATE_PROFILE_AVATAR,
    payload: { avatar },
  };
};

export const updateProfileAvatarSuccess = (avatar) => {
  return {
    type: UPDATE_PROFILE_AVATAR_SUCCESS,
    payload: avatar,
  };
};

export const updateProfileAvatarError = (error) => {
  return {
    type: UPDATE_PROFILE_AVATAR_ERROR,
    payload: error,
  };
};

export const profileApiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};
